import { render } from "./SignUp.vue?vue&type=template&id=5f7fa761&scoped=true&ts=true"
import script from "./SignUp.vue?vue&type=script&lang=ts"
export * from "./SignUp.vue?vue&type=script&lang=ts"

import "./SignUp.vue?vue&type=style&index=0&id=5f7fa761&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Anton\\Workspaces\\htdocs\\devloader-userspace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7fa761"]])

export default __exports__